/**
 * BIGO Theme Custom Script
 * Micro-interactions, mobile sticky action bar, and smooth cart drawer integrations.
 */
document.addEventListener('DOMContentLoaded', () => {
  // Mobile Sticky Buy Bar Observer on Product Pages
  const productSubmitBtn = document.querySelector('.product-form__submit');
  const stickyBar = document.querySelector('.bigo-mobile-sticky-bar');

  if (productSubmitBtn && stickyBar) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            stickyBar.style.transform = 'translateY(0)';
            stickyBar.style.opacity = '1';
          } else {
            stickyBar.style.transform = 'translateY(100%)';
            stickyBar.style.opacity = '0';
          }
        });
      },
      { threshold: 0.1 }
    );
    observer.observe(productSubmitBtn);
  }

  // Quick feedback vibration on add-to-cart (supported mobile devices)
  document.addEventListener('submit', (e) => {
    if (e.target && e.target.matches('form[action*="/cart/add"]')) {
      if ('vibrate' in navigator) {
        navigator.vibrate(50);
      }
    }
  });

  // Arabic RTL detection
  if (document.documentElement.lang === 'ar' || document.documentElement.getAttribute('dir') === 'rtl') {
    document.body.classList.add('rtl-active');
  }
});
